import { useState, useEffect, useReducer } from "react";
import "../App.css";

import { API } from "aws-amplify";
import * as React from "react";

import RadioGroup from "@mui/joy/RadioGroup";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Radio, { radioClasses } from "@mui/joy/Radio";
import FormControl from "@mui/material/FormControl";
import { listEnums } from "../graphql/slugqueries.js";

import getCharacteristicsImagePath, {
  imagePathValid,
} from "./util/imageUtil.js";

/**
 * The Generic RadioEnum Component
 * @param {String Representation of the enum typewe are trying to select}
 * @returns
 */
export default function EventEnumRadioSelector({
  enumType,
  enumMap,
  selectorSize,
  initValue,
  selectAll,
  onEvent,
  disabled
}) {
  //console.log(`Shrinking buttons by ${selectorSize}`);
  console.log("in E ERS default ", enumMap);
  const [enumList, setEnumList] = useState([]);
  const [radiovalue, setRadioValue] = useState([]);

  useEffect(() => {
    getEnums();
    setRadioValue(initValue);
  }, [enumType]);

  const updateSelection = async (event) => {
    var enumValue = event.target.value;
    if (radiovalue !== enumValue) {
      const x = await getEnum(enumValue);
      enumMap.set(enumType, enumValue);
      onEvent(event, enumValue, x);
      setRadioValue(enumValue);

      console.log(`UpdatedSelection in EVERS ${JSON.stringify(x)}`);
    }
  };

  /**
   * Get the enum list from the GraphQl API and set it in the state
   */
  async function getEnums() {
    const enumsFromSchema = await getEnum(enumType);
    // Below is used to remove any enums that dont have a valid image path
    // this is a small hack to get around db values that dont map to enums.
    let enumsToShow = [];
    for (const e in enumsFromSchema) {
      const ele = enumsFromSchema[e];
      const b = imagePathValid(enumType, ele.name);
      if (b) {
        enumsToShow.push(ele);
      }
    }
    setEnumList(enumsToShow);
  }

  async function getEnum(enumType) {
    console.log(`ENUMTYPE ${enumType}`);
    const apiData = await API.graphql({
      query: listEnums,
      variables: { name: enumType },
    });
    const enumsFromSchema = apiData.data.__type.enumValues;
    console.log(`Got... ${JSON.stringify(enumsFromSchema)}`);
    return enumsFromSchema;
  }

  // Check if the name is in the enumMap for the enumType
  function getEnumValueSelected(radiovalue, name) {
    try {
      /*console.log ("checking name is in map", radiovalue, name);
      const setting = enumMap[enumType];
      if (name === setting){
        console.log ("Yup", enumType, name);
        return true;
      }else{
        return false;
      }*/
      const b = getAlreadyInEnumMap(name);

      return b || name === radiovalue;
    } catch (error) {
      return false;
    }
  }

  function getAlreadyInEnumMap(name) {
    try {
      const value = enumMap.get(enumType);
      return name === value;
    } catch (error) {
      return false;
    }
  }

  function getEnumDefaultValue(enumType) {
    const v = enumMap.get(enumType);
    //console.log(enumType, " Defaulting to ", v);
    return v;
  }

  return (
    <FormControl disabled={disabled}>
      <RadioGroup

        aria-label="Your plan"
        value={getEnumDefaultValue(enumType) ?? null}
        name="people"
        sx={{
          flexDirection: "row",
          gap: 2,
          [`& .${radioClasses.checked}`]: {
            [`& .${radioClasses.action}`]: {
              inset: -1,
              border: "3px solid",
              borderColor: "primary.500",
            },
          },
          [`& .${radioClasses.radio}`]: {
            display: "contents",
            "& > svg": {
              zIndex: 2,
              position: "absolute",
              top: "-8px",
              right: "-8px",
              bgcolor: "background.body",
              borderRadius: "50%",
            },
          },
        }}
      >
        <List
          orientation="horizontal"
          sx={{
            minWidth: 0,
            "--List-gap": "0.5rem",
            "--ListItem-paddingY": "1rem",
            "--ListItem-paddingX": "0.25rem",
            "--ListItem-radius": "8px",
            "--ListItemDecorator-size": "32px",
          }}
        >
          {enumList.map((value, index) => (
            <ListItem
              variant="outlined"
              key={value.name}
              sx={{
                width: selectorSize,
                height: selectorSize,
                boxShadow: "sm",
                backgroundColor: "red",
                bgcolor: "background.body",
              }}
              value={value.name}
            >
              <ListItemDecorator>
                <img
                  height={selectorSize - 10}
                  alt=""
                  src={getCharacteristicsImagePath(enumType, value.name)}
                  sx={{ width: selectorSize - 20, height: selectorSize - 20 }}
                />
              </ListItemDecorator>

              <Radio
              disabled={disabled}
                id={enumType}
                checkedIcon={<CheckCircleRoundedIcon />}
                overlay
                value={value.name ?? null}
                onClick={updateSelection}
                name={value.name}
                checked={getEnumValueSelected(radiovalue, value.name)}
                sx={{
                  color: "black",
                  flexGrow: 1,
                  flexDirection: "row-reverse",
                }}
                slotProps={{
                  action: ({ checked }) => ({
                    sx: (theme) => ({
                      ...(checked && {
                        inset: 2,
                        border: "5px solid",
                        borderColor: "red",
                      }),
                    }),
                  }),
                }}
              />
            </ListItem>
          ))}
        </List>
      </RadioGroup>
    </FormControl>
  );
}

// <Avatar alt="TEST" src={process.env.PUBLIC_URL + '/images/icons8-tick-60.png'} sx={{ width: 30, height: 30 }}/>
